// extracted by css-extract-rspack-plugin
export default {"wrapper":"x0NRw","showOnHover":"CJSq1","selected":"KWOIm","scrollContainer":"BbXaa","handle":"x_DzU","placeholder":"uYuEn","commentsButton":"NHGi5"};